// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3RmtK","fileBtn":"File_fileBtn__3nOFm","closeBtn":"File_closeBtn__EkCrs","fileSelected":"File_fileSelected__1mZYK","disabled":"File_disabled__3xJI7"};